module.exports = __webpack_public_path__ + "static/img/15b.450d732.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/15b.jpg
// module id = d9Jb
// module chunks = 0